
function Footer() {
  return (
    <footer className="sec-footer">
      <div className="container-def">
        <div className="sec-footer__wrap">
          <div className="sec-footer__content">
            <div className="sec-footer__text text-info-2">© 2018 Rutesil.ru</div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;